import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext.js';
import { ThemeToggle } from '../components/ThemeToggle.js';

export function Landing() {
  const { user, signIn, loading, isDev } = useAuth();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/app/onboarding" replace />;

  // Dev mode: gather an email first, then sign in. Prod: call signIn directly
  // from the onClick — no awaits in front of signInWithPopup or Chrome blocks the popup.
  async function goDev() {
    setBusy(true);
    try { await signIn(email); } finally { setBusy(false); }
  }
  function goProd() {
    signIn();
  }

  return (
    <div className="landing-wrap landing-minimal">
      <div className="landing-header-bar">
        <span className="brand">tweet<span className="brand-accent">via</span></span>
        <ThemeToggle />
      </div>

      <main className="landing-minimal-main">
        <h1 className="landing-minimal-title">tweet<span className="brand-accent">via</span></h1>

        {isDev ? (
          <div className="signin-card" style={{ marginTop: 24 }}>
            <label className="muted small">Sign in (dev mode — any email works)</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              onKeyDown={e => { if (e.key === 'Enter' && email.includes('@')) goDev(); }}
              autoFocus
            />
            <button className="primary big" onClick={goDev} disabled={busy || !email.includes('@')}>
              {busy ? 'Signing in…' : 'Enter →'}
            </button>
          </div>
        ) : (
          <button className="primary big" onClick={goProd} disabled={loading} style={{ marginTop: 24 }}>
            Sign in with Google
          </button>
        )}

        <p className="muted small landing-minimal-footnote">Invite-only beta.</p>
      </main>
    </div>
  );
}
